import { Routes } from '@angular/router';
import { isAuthenticatedAuthGuard } from './auth.guard';
import { WeightEntryEditComponent } from './weight-entries/edit/weight-entry-edit.component';
import {
  WeightEntryOverviewComponent
} from './weight-entries/overview/weight-entries-overview/weight-entries-overview.component';
import { RabbitsOverviewComponent } from './rabbits/rabbits-overview/rabbits-overview.component';
import { EditRabbitComponent } from './rabbits/edit-rabbit/edit-rabbit.component';

export const routes: Routes = [
  {
    path: "weight-entries",
    canActivate: [
    ],
    children: [
      {
        path: "",
        component: WeightEntryOverviewComponent,
        title: "Weight Entries",
        canActivate: [isAuthenticatedAuthGuard]
      },
      {
        path: "edit/:id",
        component: WeightEntryEditComponent,
        title: "Bearbeiten",
        canActivate: [isAuthenticatedAuthGuard]
      },
      {
        path: "create",
        component: WeightEntryEditComponent,
        title: "Erstellen",
        canActivate: [isAuthenticatedAuthGuard]
      },
    ]
  },
  {
    path: "rabbits",
    children: [
      {
        path: "",
        component: RabbitsOverviewComponent,
        title: "Kaninchen",
        canActivate: [isAuthenticatedAuthGuard],
      },
      {
        path: "edit/:id",
        component: EditRabbitComponent,
        title: "Kaninchen bearbeiten",
        canActivate: [isAuthenticatedAuthGuard],
      },
      {
        path: "create",
        component: EditRabbitComponent,
        title: "Kaninchen erstellen",
        canActivate: [isAuthenticatedAuthGuard],
      }
    ]
  },
  {
    path: '',
    redirectTo: '/weight-entries',
    pathMatch: 'full'
  }
];
